import { useEffect, useRef } from 'react';
import { useAppSelector } from '../../hooks/useAppStore';

const API = import.meta.env.VITE_API_URL ?? 'http://localhost:4000/api/v2';

/**
 * LA SESIÓN DE LA EXTENSIÓN "Importar a Imperium". (02/11/2026)
 *
 * Desde la 1.5 la extensión marca sobre cada aviso de MercadoLibre si ya está en Imperium y
 * deja vincular los avisos propios a su ficha. Para preguntarle al CRM necesita la identidad
 * del agente, y el access token del CRM no le sirve: dura 15 minutos y se renueva con una
 * cookie que la extensión no tiene.
 *
 * Al entrar, si la extensión está instalada (marca `data-imperium-extension` en el <html>),
 * el CRM pide un token propio de la extensión —30 días, válido solo en `/extension/*`— y se
 * lo pasa junto con la dirección de la API. Una vez por carga del CRM: así se renueva solo
 * mientras el agente lo use. Mirando como otro usuario no se pide (el backend lo niega igual).
 */
export function useSesionDeLaExtension(): void {
  const accessToken = useAppSelector((s) => s.auth.accessToken);
  const impersonando = useAppSelector((s) => !!s.auth.user?.impersonatedBy);
  const entregada = useRef(false);

  useEffect(() => {
    if (entregada.current || !accessToken || impersonando) return;
    if (!document.documentElement.dataset.imperiumExtension) return;
    entregada.current = true;
    fetch(`${API}/extension/token`, { method: 'POST', credentials: 'include', headers: { Authorization: `Bearer ${accessToken}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        const tokenExtension = j?.data?.token;
        if (!tokenExtension) return;
        window.postMessage(
          { tipo: 'imperium-crm-sesion', tokenExtension, api: new URL(API, window.location.origin).href },
          window.location.origin,
        );
      })
      .catch(() => { entregada.current = false; });
  }, [accessToken, impersonando]);
}
